import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react'
import ReactPlaceholder from 'react-placeholder/lib'
import Controllers from '../../Api/Controllers'
import { Input, FormCustom, CheckBox } from '../../Components/Form/Form'
import Helpers from '../../Components/Helpers/Helpers'
import { SurfaceCard } from '../../Components/Ui'
import { toast } from 'react-toastify';
import JoditEditor from "jodit-react";
import ImagesModal from '../Images/ImagesModal'
import { useHistory } from 'react-router-dom'

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 44,
    padding: '0 18px',
    background: '#FF152A',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    boxShadow: '0 10px 24px rgba(255, 21, 42, 0.28)'
}

const btnGhost = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    padding: '0 16px',
    background: '#F9FAFB',
    color: '#201030',
    border: '1px solid #E5E7EB',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 12
}

const btnLink = {
    background: 'none',
    border: 'none',
    color: '#FF152A',
    fontWeight: 700,
    fontSize: '0.85rem',
    padding: 0,
    cursor: 'pointer'
}

const ArticleForm = ({ data }) => {
    const [row, setRow] = useState({
        p_id_article: data.id_article,
        p_name_article: data.name_article,
        p_state_article: data.state_article,
        p_visibility_article: data.visibility_article,
        p_date_article: data.date_article,
        p_categories: data.categories,
        p_id_images: data.id_images
    })

    const [isFileImage, setIsFileImage] = useState(false)
    const editor = useRef(null)
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [ready, setReady] = useState(false)
    const [categories, setCategories] = useState([])
    const [tags, setTags] = useState([])
    const [content, setContent] = useState('')
    const [modalShow, setModalShow] = useState(false)
    const hideModalImages = _ => setModalShow(false)

    const history = useHistory()

    const dataSubmit = useCallback(() => {
        return {
            ...row,
            p_state_article: 1,
            p_content_article: content,
            p_id_images: row.p_id_images?.id_images
        }
    }, [row, content])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.article.article_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                history.push(Helpers.config.convertUrl({ url: '/blog-historico/' }))
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
        })
    }

    const contentHTML = useMemo(() => {
        return <>
            <JoditEditor
                ref={editor}
                value={content}
                config={{
                    minHeight: 600
                }}
                tabIndex={1}
                onBlur={e => {
                    setContent(editor.current.value)
                }}
            />
        </>
    }, [editor, content])

    const handleAddFileImage = _ => {
        setIsFileImage(true)
        setModalShow(true)
    }

    useEffect(() => {
        let promises = [
            Controllers.category.get_category({
                p_state_category: 1
            }),
            Controllers.tag.get_tag()
        ]
        Promise.all(promises).then(res => {
            setCategories(res[0].data)
            setTags(res[1].data)
            setReady(true)
        })
    }, [])

    return <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
        <FormCustom viewSubmit={false} dataSubmit={dataSubmit()} onSubmit={({ data }) => {
            if (!data.p_content_article) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, ingresar contenido', toast })
                return 
            }
            if (data.p_categories.length == 0) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar departamento', toast })
                return 
            }
            if (!data.p_id_images) {
                Helpers.toast.construct({ response: 'warning', message: 'Por favor, seleccionar imagen destacada', toast })
                return 
            }
            handleInsertUpdate({ data })
        }} loadSubmit={loadSubmit}>
           <div className="col-12 col-md-8">
                <SurfaceCard className="mb-4">
                    <Input
                        text="Nombre del Blog"
                        placeholder="Nombre del Blog"
                        classNameParent=""
                        required
                        invalid="El campo es obligatorio."
                        defaultValue={row.p_name_article}
                        onChange={e => setRow({ ...row, p_name_article: e.currentTarget.value })}
                        maxLength={255}
                    />
                </SurfaceCard>
                <SurfaceCard className="mb-4">
                    <button
                        type="button"
                        style={btnGhost}
                        onClick={_ => {
                            setModalShow(true)
                            setIsFileImage(false)
                        }}
                    >
                        <i className="fa fa-images" />Buscar Imagen
                    </button>
                    {contentHTML}
                </SurfaceCard>
           </div>
           <div className="col-12 col-md-4">
                <SurfaceCard title="Publicar" className="mb-4">
                    <div className="d-flex flex-column">
                            <div className="d-flex align-items-center mb-2">
                                <i className="fa fa-key mr-2" style={{
                                    minWidth: '10px'
                                }}></i>
                                <span className="mr-2">Estado:</span>
                                <strong>{parseInt(data.state_article) === 1 ? 'Publicado' : 'En Creación'}</strong>
                            </div>
                            <div className="d-flex align-items-center mb-2">
                                <i className="fa fa-eye mr-2" style={{
                                    minWidth: '10px'
                                }}></i>
                                <span className="mr-2">Visibilidad:</span>
                                <strong>Público</strong>
                            </div>
                            <div className="d-flex align-items-center mb-4">
                                <i className="fa fa-calendar-alt mr-2" style={{
                                    minWidth: '10px'
                                }}></i>
                                <span className="mr-2" style={{ minWidth: '90px' }}>Publicado el:</span>
                                <strong>{parseInt(data.state_article) === 1 ? '10 Diciembre 2020 a las 11:44' : 'Pendiente'}</strong>
                            </div>
                            <button type="submit" style={btnPrimary}>
                                {loadSubmit
                                    ? <i className="fa fa-circle-notch fa-spin" />
                                    : <><i className="fa fa-plus" />Registrar</>}
                            </button>
                        </div>
                </SurfaceCard>
                <SurfaceCard title="Departamento" className="mb-4">
                    {React.Children.toArray(categories.map(c => {
                            return <CheckBox
                                id={'chk-category-' + c.id_category}
                                text={c.name_category}
                                checked={row.p_categories.some(cc => parseInt(cc.id_category) === parseInt(c.id_category))}
                                onChange={e => {
                                    if (e.currentTarget.checked) {
                                        setRow({ ...row, p_categories: [ c ] })
                                    } else {
                                        setRow({ ...row, p_categories: row.p_categories.filter(cc => parseInt(cc.id_category) !== parseInt(c.id_category)) })
                                    }
                                }}
                            />
                        }))}
                </SurfaceCard>
                <SurfaceCard title="Imagen Destacada">
                    {row.p_id_images?.file_images
                        ? <img className="img-thumbnail hover-effect cur-pointer" onClick={handleAddFileImage} src={Helpers.config.resourcesUrl({ url: row.p_id_images.file_images })} width="150" alt="" />
                        : <button type="button" style={btnLink} onClick={handleAddFileImage}>Sin imagen destacada</button>}
                </SurfaceCard>
           </div>
        </FormCustom>
        <ImagesModal modalShow={modalShow} handleHideModalForm={hideModalImages} addImage={l => {
            if (isFileImage) {
                setRow({ ...row, p_id_images: l })
            } else {
                setContent(content + `<img src="${Helpers.config.resourcesUrl({ url: l.file_images })}" width="150" alt="${l.alt_images}" />`)
            }
        }} />
    </ReactPlaceholder>
}

ArticleForm.defaultProps = {
    data: {
       id_article: '',
       content_article: '',
       state_article: '0',
       visibility_article: '1',
       date_article: '',
       categories: [],
       id_images: {}
    },
    onSubmit: () => {},
    loadSubmit: false
}

export default ArticleForm;
